import { render } from "./address-comp.vue?vue&type=template&id=f6c31f9c&scoped=true"
import script from "./address-comp.vue?vue&type=script&lang=js"
export * from "./address-comp.vue?vue&type=script&lang=js"

import "./address-comp.vue?vue&type=style&index=0&id=f6c31f9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6c31f9c"]])

export default __exports__